import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { CourtDocVerification } from "./sopDataTemplate";

interface AllProps {
  data: CourtDocVerification;
  handleCourtVerifyChange: any;
  bgColor?: string;
}
export class CourtDocVerify extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
  };

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleInputChange = (key, name, val) => {
    const { data } = this.props;
    data[key][name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleCourtVerifyChange(data);
  };
  render() {
    const { data } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data.bgColor ? data.bgColor : bgColor }}
              as={Card.Header}
              eventKey="7"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Court Document Verification</b>
              </h5>
              <i
                className={`icon feather icon-${!isOptionOpen ? "plus" : "minus"}`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="7">
              <Card.Body>
                 <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Court Document Verify</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowCourtDocStatus"
                        type="radio"
                        id="isshowCourtDocStatus-yes"
                        checked={data.isshowCourtDocStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowCourtDocStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowCourtDocStatus"
                        type="radio"
                        id="isshowCourtDocStatus-no"
                        checked={data.isshowCourtDocStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowCourtDocStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Partition Suit</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowPartitionSuitStatus"
                        type="radio"
                        id="isshowPartitionSuitStatus-yes"
                        checked={data.isshowPartitionSuitStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowPartitionSuitStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowPartitionSuitStatus"
                        type="radio"
                        id="isshowPartitionSuitStatus-no"
                        checked={data.isshowPartitionSuitStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowPartitionSuitStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Final Decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="partitionSuit-isFinalDecree"
                          type="radio"
                          checked={data.partitionSuit.isFinalDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isFinalDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="partitionSuit-isFinalDecree"
                          type="radio"
                          checked={!data.partitionSuit.isFinalDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isFinalDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Preliminary Decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="partitionSuit-isPreliminaryDecree"
                          type="radio"
                          checked={data.partitionSuit.isPreliminaryDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isPreliminaryDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="partitionSuit-isPreliminaryDecree"
                          type="radio"
                          checked={!data.partitionSuit.isPreliminaryDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isPreliminaryDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Compromise Decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="partitionSuit-isCompormiseDecree"
                          type="radio"
                          checked={data.partitionSuit.isCompormiseDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isCompormiseDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="partitionSuit-isCompormiseDecree"
                          type="radio"
                          checked={!data.partitionSuit.isCompormiseDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isCompormiseDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Expert decree
                        
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="partitionSuit-isExpartyDecree"
                          type="radio"
                          checked={data.partitionSuit.isExpartyDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isExpartyDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="partitionSuit-isExpartyDecree"
                          type="radio"
                          checked={!data.partitionSuit.isExpartyDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "isExpartyDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Contested Decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="partitionSuit-ContestedDecree"
                          type="radio"
                          checked={data.partitionSuit.ContestedDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "ContestedDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="partitionSuit-ContestedDecree"
                          type="radio"
                          checked={!data.partitionSuit.ContestedDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "partitionSuit",
                              "ContestedDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>
                        Declaration Suit/ Permanent (or) Temporary Injection
                      </b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowDeclarationSuitStatus"
                        type="radio"
                        id="isshowDeclarationSuitStatus-yes"
                        checked={data.isshowDeclarationSuitStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowDeclarationSuitStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowDeclarationSuitStatus"
                        type="radio"
                        id="isshowDeclarationSuitStatus-no"
                        checked={data.isshowDeclarationSuitStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowDeclarationSuitStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        IA No Available?
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="declarationSuit-isIAAvailable"
                          type="radio"
                          checked={data.declarationSuit.isIAAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isIAAvailable",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="declarationSuit-isIAAvailable"
                          type="radio"
                          checked={!data.declarationSuit.isIAAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isIAAvailable",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Contest Decree Available
                      </label>

                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="declarationSuit-isContest"
                          type="radio"
                          checked={data.declarationSuit.isContest}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isContest",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="declarationSuit-isContest"
                          type="radio"
                          checked={!data.declarationSuit.isContest}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isContest",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Compromise Decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="declarationSuit-isCompormiseDecree"
                          type="radio"
                          checked={data.declarationSuit.isCompormiseDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isCompormiseDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="declarationSuit-isCompormiseDecree"
                          type="radio"
                          checked={!data.declarationSuit.isCompormiseDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isCompormiseDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Expert decree
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="declarationSuit-isExpartyDecree"
                          type="radio"
                          checked={data.declarationSuit.isExpartyDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isExpartyDecree",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="declarationSuit-isExpartyDecree"
                          type="radio"
                          checked={!data.declarationSuit.isExpartyDecree}
                          onChange={() =>
                            this.handleInputChange(
                              "declarationSuit",
                              "isExpartyDecree",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Lok Adalat</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowLokAdalatStatus"
                        type="radio"
                        id="isshowLokAdalatStatus-yes"
                        checked={data.isshowLokAdalatStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowLokAdalatStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowLokAdalatStatus"
                        type="radio"
                        id="isshowLokAdalatStatus-no"
                        checked={data.isshowLokAdalatStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowLokAdalatStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Old Court Name
                      </label>
                      <input
                        className="form-control"
                        name="oldCourtName"
                        type="text"
                        value={data.lokAdalat.oldCourtName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "lokAdalat",
                            "oldCourtName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Case No
                      </label>
                      <input
                        className="form-control"
                        name="caseNo"
                        type="text"
                        value={data.lokAdalat.caseNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "lokAdalat",
                            "caseNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Lok Adalat Case No
                      </label>
                      <input
                        className="form-control"
                        name="lokAdalatCaseNo"
                        type="text"
                        value={data.lokAdalat.lokAdalatCaseNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "lokAdalat",
                            "lokAdalatCaseNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Specific Performance/ Suit</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowSpecificSuitStatus"
                        type="radio"
                        id="isshowSpecificSuitStatus-yes"
                        checked={data.isshowSpecificSuitStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowSpecificSuitStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowSpecificSuitStatus"
                        type="radio"
                        id="isshowSpecificSuitStatus-no"
                        checked={data.isshowSpecificSuitStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowSpecificSuitStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mb-10">
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Agreement Holder Name
                      </label>
                      <input
                        className="form-control"
                        name="agreementHolderName"
                        type="text"
                        value={data.specificSuit.agreementHolderName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "specificSuit",
                            "agreementHolderName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        OS No
                      </label>
                      <input
                        className="form-control"
                        name="osNo"
                        type="text"
                        value={data.specificSuit.osNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "specificSuit",
                            "osNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        EP No
                      </label>
                      <input
                        className="form-control"
                        name="epNo"
                        type="text"
                        value={data.specificSuit.epNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "specificSuit",
                            "epNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Appeal</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowAppealStatus"
                        type="radio"
                        id="isshowAppealStatus-yes"
                        checked={data.isshowAppealStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowAppealStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowAppealStatus"
                        type="radio"
                        id="isshowAppealStatus-no"
                        checked={data.isshowAppealStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowAppealStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Lower Court Name
                      </label>
                      <input
                        className="form-control"
                        name="lowerCourtName"
                        type="text"
                        value={data.appeal.lowerCourtName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "lowerCourtName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Lower Court Case No
                      </label>
                      <input
                        className="form-control"
                        name="lowerCourtcaseNo"
                        type="text"
                        value={data.appeal.lowerCourtcaseNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "lowerCourtcaseNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Appeal Court Name
                      </label>
                      <input
                        className="form-control"
                        name="appealCourtName"
                        type="text"
                        value={data.appeal.appealCourtName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "appealCourtName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Appeal Case No
                      </label>
                      <input
                        className="form-control"
                        name="appealCaseNo"
                        type="text"
                        value={data.appeal.appealCaseNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "appealCaseNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <div className="row">
                        <div className="col-md-8">
                          <label className="label" style={{ padding: 0 }}>
                            In Appeal Verdict, is It Lower Court Confirm?
                          </label>
                        </div>
                        <div className="col-md-4">
                          <div className="row" style={{ marginLeft: 0 }}>
                            <Form.Check
                              inline
                              label="Yes"
                              name="appeal-isLowerCourt"
                              type="radio"
                              checked={data.appeal.isLowerCourt}
                              onChange={() =>
                                this.handleInputChange(
                                  "appeal",
                                  "isLowerCourt",
                                  true,
                                )
                              }
                            />
                            <Form.Check
                              inline
                              label="No"
                              name="appeal-isLowerCourt"
                              type="radio"
                              checked={!data.appeal.isLowerCourt}
                              onChange={() =>
                                this.handleInputChange(
                                  "appeal",
                                  "isLowerCourt",
                                  false,
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Lower Court Judjment reversed
                      </label>
                      <input
                        className="form-control"
                        name="lowerCourtReverse"
                        type="text"
                        value={data.appeal.lowerCourtReverse}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "lowerCourtReverse",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Lower Court Judjement Confirm
                      </label>
                      <input
                        className="form-control"
                        name="alter"
                        type="text"
                        value={data.appeal.alter}
                        onChange={(e) =>
                          this.handleInputChange(
                            "appeal",
                            "alter",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>Purchase From Court Auction</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowCourtAuctionPurchaseStatus"
                        type="radio"
                        id="isshowCourtAuctionPurchaseStatus-yes"
                        checked={data.isshowCourtAuctionPurchaseStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowCourtAuctionPurchaseStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowCourtAuctionPurchaseStatus"
                        type="radio"
                        id="isshowCourtAuctionPurchaseStatus-no"
                        checked={
                          data.isshowCourtAuctionPurchaseStatus === false
                        }
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowCourtAuctionPurchaseStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        OS No
                      </label>
                      <input
                        className="form-control"
                        name="osNo"
                        type="text"
                        value={data.courtAuctionPurchase.osNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "courtAuctionPurchase",
                            "osNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        EP No
                      </label>
                      <input
                        className="form-control"
                        name="epNo"
                        type="text"
                        value={data.courtAuctionPurchase.epNo}
                        onChange={(e) =>
                          this.handleInputChange(
                            "courtAuctionPurchase",
                            "epNo",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Successfull Bidder Name
                      </label>
                      <input
                        className="form-control"
                        name="bidderName"
                        type="text"
                        value={data.courtAuctionPurchase.bidderName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "courtAuctionPurchase",
                            "bidderName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label
                        className="label"
                        style={{ padding: 0, marginTop: "10px" }}
                      >
                        Property Holder Name
                      </label>
                      <input
                        className="form-control"
                        name="propertyHolderName"
                        type="text"
                        value={data.courtAuctionPurchase.propertyHolderName}
                        onChange={(e) =>
                          this.handleInputChange(
                            "courtAuctionPurchase",
                            "propertyHolderName",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Bank Mortage Involved?
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="courtAuctionPurchase-isBankMortageInvolved"
                          type="radio"
                          checked={
                            data.courtAuctionPurchase.isBankMortageInvolved
                          }
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isBankMortageInvolved",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="courtAuctionPurchase-isBankMortageInvolved"
                          type="radio"
                          checked={
                            !data.courtAuctionPurchase.isBankMortageInvolved
                          }
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isBankMortageInvolved",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Mother/Title Available?
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="courtAuctionPurchase-isMotherAvailable"
                          type="radio"
                          checked={data.courtAuctionPurchase.isMotherAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isMotherAvailable",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="courtAuctionPurchase-isMotherAvailable"
                          type="radio"
                          checked={!data.courtAuctionPurchase.isMotherAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isMotherAvailable",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Sales Certificate Available?
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="courtAuctionPurchase-isSalesAvailable"
                          type="radio"
                          checked={data.courtAuctionPurchase.isSalesAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isSalesAvailable",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="courtAuctionPurchase-isSalesAvailable"
                          type="radio"
                          checked={!data.courtAuctionPurchase.isSalesAvailable}
                          onChange={() =>
                            this.handleInputChange(
                              "courtAuctionPurchase",
                              "isSalesAvailable",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h6>
                      <b>SARFESI Proceeding</b>
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <Form.Check
                        inline
                        label="Yes"
                        name="isshowSarfesiProceedingStatus"
                        type="radio"
                        id="isshowSarfesiProceedingStatus-yes"
                        checked={data.isshowSarfesiProceedingStatus === true}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowSarfesiProceedingStatus = true;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                        style={{ marginRight: "15px" }}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isshowSarfesiProceedingStatus"
                        type="radio"
                        id="isshowSarfesiProceedingStatus-no"
                        checked={data.isshowSarfesiProceedingStatus === false}
                        onChange={() => {
                          const newData = { ...data };
                          newData.isshowSarfesiProceedingStatus = false;
                          this.changeBgColor();
                          newData.bgColor = "lightgreen";
                          this.props.handleCourtVerifyChange(newData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-10">
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Possession Notice Date(Period 60 day Expired)
                      </label>
                      <input
                        className="form-control"
                        name="possessionDate"
                        type="text"
                        value={data.sarfesiProceeding.possessionDate}
                        onChange={(e) =>
                          this.handleInputChange(
                            "sarfesiProceeding",
                            "possessionDate",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Symbolic Possession Date (Period 60 day Expired)
                      </label>
                      <input
                        className="form-control"
                        name="symbolicPossession"
                        type="text"
                        value={data.sarfesiProceeding.symbolicPossession}
                        onChange={(e) =>
                          this.handleInputChange(
                            "sarfesiProceeding",
                            "symbolicPossession",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Borrower Notice Date
                      </label>
                      <input
                        className="form-control"
                        name="borrowerNotice"
                        type="text"
                        value={data.sarfesiProceeding.borrowerNotice}
                        onChange={(e) =>
                          this.handleInputChange(
                            "sarfesiProceeding",
                            "borrowerNotice",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="label" style={{ padding: 0 }}>
                        Auction Date
                      </label>
                      <input
                        className="form-control"
                        name="auctionDate"
                        type="text"
                        value={data.sarfesiProceeding.auctionDate}
                        onChange={(e) =>
                          this.handleInputChange(
                            "sarfesiProceeding",
                            "auctionDate",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Paid 15 Percent?
                      </label>
                      <div className="row " style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="sarfesiProceeding-isPaid15Percent"
                          type="radio"
                          checked={data.sarfesiProceeding.isPaid15Percent}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isPaid15Percent",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="sarfesiProceeding-isPaid15Percent"
                          type="radio"
                          checked={!data.sarfesiProceeding.isPaid15Percent}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isPaid15Percent",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Sales Certificate Obtained
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="sarfesiProceeding-isSalesCertificate"
                          type="radio"
                          checked={data.sarfesiProceeding.isSalesCertificate}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isSalesCertificate",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="sarfesiProceeding-isSalesCertificate"
                          type="radio"
                          checked={!data.sarfesiProceeding.isSalesCertificate}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isSalesCertificate",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-4">
                      <label className="label" style={{ padding: 0 }}>
                        Registered
                      </label>
                      <div className="row" style={{ marginLeft: 0 }}>
                        <Form.Check
                          inline
                          label="Yes"
                          name="sarfesiProceeding-isRegistered"
                          type="radio"
                          checked={data.sarfesiProceeding.isRegistered}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isRegistered",
                              true,
                            )
                          }
                        />
                        <Form.Check
                          inline
                          label="No"
                          name="sarfesiProceeding-isRegistered"
                          type="radio"
                          checked={!data.sarfesiProceeding.isRegistered}
                          onChange={() =>
                            this.handleInputChange(
                              "sarfesiProceeding",
                              "isRegistered",
                              false,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default CourtDocVerify;
